// TODO: refactor anything calling this, only using this until everything is on the sagas
const getCurrentUid = () => global && global.localStorage && global.localStorage.getItem('uid')

export default getCurrentUid



// WEBPACK FOOTER //
// ./src/utilities/getCurrentUid.js